// firebase config
const firebaseConfig = {
  apiKey: "AIzaSyABgG3sDIF430TflW1KVF-tD6otNYoQavY",
  authDomain: "portfolio-cefc9.firebaseapp.com",
  projectId: "portfolio-cefc9",
  storageBucket: "portfolio-cefc9.appspot.com",
  messagingSenderId: "953633254861",
  appId: "1:953633254861:web:098cad3a8de668c16a6884",
};
export default firebaseConfig;
